<template>
  <div id="chatInput">
    <input type="text" v-model="inputValue" id="chatInputArea" class="ieInputXClear" placeholder="메세지 입력하기"
      autocomplete="off" @keypress.enter="printMessage" @click="scrollBottom" />
    <button :style="buttonStyle" id="chatInputButton" @click="printMessage" />
  </div>
</template>

<script>
import * as Cookies from 'js-cookie'
import chatSettingMenuIcon from './chat-setting-menu'

export default {
  data: function () {
    return {
      'inputValue': ''
    }
  },
  computed: {
    buttonStyle() {
      let mainHost = "nmd.co"
      const host = window.location.host
      if (host.includes("named.com")) {
        mainHost = "named.com"
      } else if (host.includes("xn--950bo4em5v.co")) {
        mainHost = "xn--950bo4em5v.co"
      } else if (host.includes("named.net")) {
        mainHost = "named.net"
      } else if (host.includes("named2.net")) {
        mainHost = "named2.net"
      } else if (host.includes("named2.kr")) {
        mainHost = "named2.kr"
      }

      if (this.inputValue.trim()) {
        return {
          background: "url(/nlivechat/img/sp_chat_arrow_red.png) no-repeat",
          backgroundSize: 'contain'
        };
      } else {
        return {
          background: `url('https://image.${mainHost}/portal/sp_chat_icons.png?v=1') -145px -169px /225px 199px no-repeat`
        };
      }
    }
  },
  methods: {
    scrollBottom() {
      let screen = document.getElementById('chatMessageList')
      screen.scrollTop = screen.scrollHeight
    },
    printMessage(event, message) {
      // console.log('printMessage', this)
      // 도배금지 체크
      if (!is_login) { // eslint-disable-line
        return false
      }
      let chatInputArea = this.inputValue
      this.inputValue = ''

      if (chatInputArea.length < 1) {
        return false
      }

      if (member_no === '') { // eslint-disable-line
        printNotifyMessage('손님은 로그인후 채팅에 참여할수 있습니다.'); // eslint-disable-line
        window.parent.postMessage({ commend: 'show_login_popup_layer', popupCommend: '', href: '' }, '*')
        return false
      }

      if (is_prisoner) { // eslint-disable-line
        printNotifyMessage('전과로 인해 ' + released_date + '일부터 채팅에 참여할수 있습니다.') // eslint-disable-line
        return false
      }

      if (!is_allow_chat) { // eslint-disable-line
        printMessage('보유하신 포인트(또는 GP)가 부족합니다. 20,000 포인트(또는 GP) 필요', 'notify needPoint') // eslint-disable-line
        printMessage('바로채팅 아이템을 구매 사용 하시면, 포인트(또는 GP)에 상관없이 채팅 가능합니다.', 'notify shop') // eslint-disable-line
        if (parent && parent.mainFrame) {
          parent.mainFrame.location.href = '/market/itemshop/item_chat.php'
        }
        return false
      }

      var testMsg = chatInputArea.toLowerCase().replace(/"/g, '')
      for (var i = 0; i < filter_words.length; i++) { // eslint-disable-line
        if (testMsg.indexOf(filter_words[i]) >= 0) { // eslint-disable-line
          printWarningMessage('입력하신 [' + filter_words[i] + '] (은)는 금지어입니다.') // eslint-disable-line
          this.inputValue = chatInputArea
          return
        }
      }

      if (is_dobae === true) { // eslint-disable-line
        // 도배금지 남은시간 체크
        var remind_second = parseInt(10 - (Date.now() - last_msg_send_time) / 1000) // eslint-disable-line
        remind_second = remind_second > 9 ? 10 : remind_second // eslint-disable-line
        printErrorMessage('도배금지. ' + (remind_second + 1) + '초간 채팅이 금지됩니다.') // eslint-disable-line
        return false
      } else {
        if (checkDobae(chatInputArea)) { // eslint-disable-line
          return false
        }

        if (Cookies.get('block_pc')) { // eslint-disable-line
          printWarningMessage('채팅이 일시적으로 차단된 PC입니다.') // eslint-disable-line
          return false
        }
      }

      if (chatInputArea.length > 120) {
        printErrorMessage('채팅 최대 글자를 초과하였습니다.') // eslint-disable-line
        this.inputValue = chatInputArea
        return false
      }

      var userid = window.userid
      var username = window.username
      var faceicon = window.face_icon

      if (chatInputArea !== '') {
        // init value for test
        // console.log(userid, username, face_icon)
        if (!userid || userid === '') {
          userid = 'unnamed'
        }
        if (!username || username === '') {
          username = 'unnamed'
        }
        if (!faceicon || faceicon === '') { // eslint-disable-line camelcase
          faceicon = '' // eslint-disable-line camelcase
        }

        // send message to server
        var attribute = ''

        if (this.level >= 5) {
          attribute = 'lv5'
        } else if (this.level === 4) {
          attribute = 'lv4'
        }
        var messageProtocol = {
          cmd: 'MSG',
          face_icon: faceicon, // eslint-disable-line no-undef
          userid: userid, // eslint-disable-line no-undef
          username: username, // eslint-disable-line no-undef
          msg: chatInputArea,
          style: attribute
        }
        // console.log('printMessage messageProtocol', messageProtocol)
        // send message to server
        window.sendToLobby(messageProtocol) // eslint-disable-line no-undef

        // Google Analytics
        try {
        } catch (e) { }
      }
    }
  },
  components: {
    'chatSettingMenuIcon': chatSettingMenuIcon
  }
}
</script>

<style lang="scss">
#chatInput {
  position: fixed;
  bottom: 0;
  width: 100%;
  right: 1px;
  letter-spacing: -5px;

  #chatInputArea {
    width: 100%;
    height: 50px;
    line-height: 50px;
    padding-left: 20px;
    border: 1px solid #dee3eb;
    border-right: none;
    font-size: 12px;
    font-family: Gulim, '맑은 고딕', sans-serif;
    padding-right: 15%;

    &::placeholder {
      color: #aaa;
    }
  }

  #chatInputButton {
    position: absolute;
    right: 10px;
    bottom: 10px;
    border: 0;
    font-size: 25px;
    height: 30px;
    width: 30px;
    //background: url("https://image.named.com/portal/sp_chat_icons.png?v=1") -145px -169px /225px 199px no-repeat;
    cursor: pointer;
  }

  .ieInputXClear::-ms-clear {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// chat-input.vue?4987e224